import { LabelCardIconVariety } from "@elements/Icon/LabelCardIcon";
import { OKTAUserTypeEnum } from "@hooks/useUserInfo";

import type { PlaylistItem } from "../BeyondWordsPlaylist";

export const canAccessPlaylistItem = (
  item: PlaylistItem,
  userType?: OKTAUserTypeEnum,
  isGenGUser?: boolean,
) => {
  if (item.isGenG) return !!isGenGUser;

  switch (userType) {
    case OKTAUserTypeEnum.SUBSCRIBER:
      return true;

    case OKTAUserTypeEnum.REGISTERED:
      return item.contentAccess !== LabelCardIconVariety.PREMIUM;

    default:
      return item.contentAccess === LabelCardIconVariety.FREE;
  }
};
